// react
import React, { useEffect } from 'react'

// global components
import Header from 'components/Header'
import Footer from 'components/Footer'

// local components
import HeroSection from './components/HeroSection'
import AboutUs from './components/AboutUs'
import OurLawyers from './components/OurLawyers'
import OurServices from './components/OurServices'
import Whatsapp from 'components/Whatsapp/Whatsapp'

function Home() {
  return (
    <main className='relative overflow-hidden'>
      <Header />
      <HeroSection />
      <AboutUs />
      <OurLawyers />
      <OurServices />
      <Footer />
      <Whatsapp />
    </main>
  )
}

export default Home
